import React, { Component, Fragment } from 'react';
import { Row, Col, Label, Button } from "reactstrap";
import { inject, observer } from "mobx-react";
import NumberFormat from 'react-number-format';
import { IconeDelete, IconeSoma } from '../../comum/components/Icones';
import DetalhesImpBlCntr from './DetalhesImpBlCntr';
import AddServicosAcessorios from './AddServicosAcessorios';
import { E_CONDICAO, E_TIPO_CLIENTE, E_TIPO_TELA } from '../stores/Enum';
import ServicosAcessoriosPopOver from './ServicosAcessoriosPopOver';

@inject("store")
@observer
export default class DetalhesImpBl extends Component {
    constructor(props) {
        super(props)

        this.dataStore = this.props.controllers.dataStore;
        this.viewStore = this.props.controllers.viewStore;
        this.filterStore = this.props.controllers.filterStore;
        this.impStore = this.props.controllers.impStore;
        this.appStore = this.props.store.appStore;
        this.modalStore = this.props.store.modalStoreCustom;        
    }
    
    componentDidMount() {         
    }

    render() {
        const { bl: { NumBl, Items, ValorCif, Erros }, index } = this.props;

        const temArmador = this.filterStore.tipoCliente == E_TIPO_CLIENTE.Armador;

        const permiteMultiplosCntr = !temArmador && this.impStore.showOptionHouse;
        const showTitle = this.appStore.isMobile || index === 0 || permiteMultiplosCntr;

        const servicosAcessoriosPorItem = this.impStore.getServicosIncluidosPorIndex(index).filter(s => s.Basico == E_CONDICAO.Nao);
        
        const ErroItem = Erros['Item'];

        return (
            <Fragment>
                {this.appStore.isMobile && permiteMultiplosCntr && index > 0 && <hr />}
                <Row className="w-100">
                    <Col xs={1} sm={1} md={1} lg={1} xl={1} className="d-flex flex-column align-items-center mb-3" >
                        {showTitle &&
                            <Label className="font-weight-bold" style={{ borderBottom:'2px solid #001C43', maxWidth: 'max-content' }}>Nº</Label>
                        }
                        <Label className="font-weight-bold pt-2">{NumBl}</Label>
                    </Col>
                    <Col xs={11} sm={11} md={temArmador ? 9 : this.impStore.showOptionHouse ? 8 : 6} lg={temArmador ? 9 : this.impStore.showOptionHouse ? 8 : 6} xl={temArmador ? 9 : this.impStore.showOptionHouse ? 8 : 6} className="pr-0 pl-0">
                        {Items.map((item, itemIndex, array) => (
                            <Fragment key={itemIndex}>
                                <DetalhesImpBlCntr
                                    {...this.props}
                                    item={item}
                                    index={itemIndex}
                                    blIndex={index}
                                    showDelete={array.length > 1}
                                />
                            </Fragment>                     
                        ))}
                        {permiteMultiplosCntr && (
                            <Row className="d-flex align-items-center">
                                <Button 
                                    className="ml-0 mt-3 btn-com-bordas-primary" 
                                    onClick={() => this.impStore.addItemBl(index)} 
                                    disabled={this.viewStore.servicosAtivo}
                                >
                                    + Adicionar novo tipo de container(s)
                                </Button>
                            </Row>
                        )}
                    </Col>
                    {!temArmador && (
                        <Col xs={12} sm={12} md={5} lg={2} xl={2}>
                            {showTitle && <Label>Valor CIF</Label>}
                            <NumberFormat
                                style={{padding:"8px 6px", width:"100%"}}
                                allowNegative={false}
                                className="form-control"
                                thousandSeparator="."
                                decimalSeparator=","
                                prefix="R$ "
                                value={ValorCif ? ValorCif : ''}
                                onChange={(event) => this.impStore.setBl(index, 'ValorCif', event.target.value)}
                                disabled={this.viewStore.servicosAtivo}
                            />
                            {(Erros['ValorCif']) && <Label className="label-danger">{Erros['ValorCif']}</Label>}
                        </Col>
                    )}
                    {!this.viewStore.servicosAtivo && this.impStore.data.value.Bls.length > 1 &&
                        <Col xs={12} sm={12} md={6} lg={1} xl={1} className={"d-flex flex-column"}>
                            {showTitle && <Label className="footer-select--label">&nbsp;</Label>} 
                            <Button outline className="collapseItem"
                                onClick={() => this.impStore.removeBl(index)}>
                                <IconeDelete tamanho="sm" />
                            </Button>
                        </Col>                    
                    }
                    {this.viewStore.servicosAtivo && this.impStore.showOptionPier &&
                        <Col xs={12} sm={12} md={6} lg={2} xl={2} className="pb-3 d-flex align-items-end" >
                            <div className="w-100 d-flex flex-column">
                                {showTitle && <Label className="footer-select--label">Serviços</Label>}
                                <AddServicosAcessorios
                                    className="collapseItem mr-3"
                                    controllers={this.props.controllers}
                                    tipoTela={E_TIPO_TELA.Importacao}
                                    items={[this.impStore.getItem(index)]}
                                >
                                    <IconeSoma tamanho="sm" />
                                </AddServicosAcessorios>
                            </div>
                            {servicosAcessoriosPorItem.length > 0 && (
                                <ServicosAcessoriosPopOver
                                    servicosAcessorios={servicosAcessoriosPorItem}
                                    removeServico={this.impStore.removeServico}
                                />
                            )}
                        </Col>
                    }
                </Row>
                {ErroItem && 
                    <div className="d-flex p-1 mb-4 mt-n3 align-self-center col-11"
                        style={{borderRadius: '5px', backgroundColor: 'rgba(234, 84, 85, 0.12)'}}
                    >
                        <div className="d-flex w-100 justify-content-center align-items-center">
                            <div style={{color: '#ea5455', fontWeight: '800'}}> 
                                {ErroItem}
                            </div>
                        </div>
                    </div>                    
                }   
            </Fragment>
        )
    }
}


// WEBPACK FOOTER //
// ./src/modules/simulacao-servicos/components/DetalhesImpBl.js